/**
 * @short_description UI Component to facilitate the form functionality. Underlying it is using the antd form component.
 *
 * @author  Hemant Kumar Goyal <@hemantkumar.goyal>
 *
 * @reference https://ant.design/components/form
 *
 * @description Since the form element extracts some top level API's which can be used directly in the component such as creation of validation,
 * submission of the form using the API, resetting of the form since we have assigned the form instance directlyto our internal form
 * component.
 *
 * @returns {instanceof Form}
 */

import { Form as FormCore } from 'antd';

const Form = FormCore;

export default Form;
